require('./bootstrap');

import '@/plugins/vue-composition-api';
import '@/styles/styles.scss';
import Vue from 'vue';
import './registerServiceWorker';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import './axios';
import './firebaseConfig';
import Notifications from 'vue-notification';
import VueSweetalert2 from 'vue-sweetalert2';
import VueProgressBar from 'vue-progressbar';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LCircle } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import { Icon } from 'leaflet';
import i18n from './i18n';

const options = {
  color: '#9155fd',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.5s',
    opacity: '0.6s',
    termination: 500,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, options);

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
Vue.use(Notifications);
require('moment/locale/sq');
Vue.use(require('vue-moment'));

import browserDetect from 'vue-browser-detect-plugin';
Vue.use(browserDetect);

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps);

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-icon', LIcon);
Vue.component('l-circle', LCircle);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import AuthService from '@/services/AuthService';
Vue.mixin({
  computed: {
    $isDirector() {
      return AuthService.getLoggedInUserRole() === 'director';
    },
  },
});

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

global.vm = app;
